<!--
/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="apcwo-pr-download">
    <oxd-button
      label="Download DOCX"
      icon-name="download"
      display-type="ghost"
      @click="download('docx')"
    />
    <oxd-button
      label="Download PDF"
      icon-name="download"
      display-type="ghost"
      @click="download('pdf')"
    />
  </div>
</template>

<script>
import {downloadUrl} from '../util/helpers';

export default {
  name: 'DownloadButtons',
  props: {
    reviewId: {
      type: Number,
      required: true,
    },
    scope: {
      type: String,
      default: 'employee',
    },
  },
  methods: {
    download(format) {
      window.location.href = downloadUrl(this.reviewId, this.scope, format);
    },
  },
};
</script>

<style>
.apcwo-pr-download {
  display: inline-flex;
  gap: 8px;
}
</style>
